<div class="content">
  <automata-automation-replacement-chips
    label="AUTOMATIONS.EDITOR.TASKS.CAMPAIGNS.COMMON.CAMPAIGN"
    [hint]="selectorHint"
    [noResultsWarning]="'AUTOMATIONS.EDITOR.TASKS.CAMPAIGNS.START_GENERAL.NO_CAMPAIGNS_FOUND'"
    [noResultsFound]="'AUTOMATIONS.EDITOR.TASKS.CAMPAIGNS.START_GENERAL.NO_SEARCH_RESULTS'"
    [dataService]="campaignSelectorService"
    [formControl]="campaignIdControl"
    [supportDataPassing]="false"
    [isRequired]="true"
    [disableIfTemplate]="true"
    [multiple]="false"
    (finishedInitialLoading)="finishedLoadingSelector()"
    [extraData]="{ senderType: senderType }"
  ></automata-automation-replacement-chips>
</div>
